import { Pipe, PipeTransform } from "@angular/core";
import { Files } from "../../app/api/packbo/models/files";
import { environment } from "../../environments/environment";

@Pipe({
    name: "getDirectusFile",
    standalone: true,
    pure: true
})
export class GetDirectusFilePipe implements PipeTransform {
    transform(fileId: Files | string | null | undefined): string {
        if (typeof fileId === "string") {
            return `${environment.directusUrl}/assets/${fileId}`;
        }

        return `${environment.directusUrl}/assets/${fileId?.id}`;
    }
}
